/**
 * number of bins before switching to dense mode
 * @internal
 */
export const DENSE_HISTOGRAM = 19;
/**
 * minimal width of a column to show the label in the header
 * @internal
 */
export const MIN_LABEL_WIDTH = 30;
/**
 * number of milliseconds to wait before a hovered canvas row will be replaced with a DOM one
 * @type {number}
 * @internal
 */
export const HOVER_DELAY_SHOW_DETAIL = 500;

export const GUESSED_ROW_HEIGHT = 18;
export const GUESSES_GROUP_HEIGHT = 40;
